import { Controller } from "@hotwired/stimulus"

// Zona de arrastre para inputs de archivo: muestra los nombres elegidos y
// resalta el borde mientras se arrastra encima.
export default class extends Controller {
  static targets = ["input", "filename"]
  static classes = ["dragging"]
  static values = { placeholder: { type: String, default: "Agrega tu imagen" } }

  changed() {
    const files = Array.from(this.inputTarget.files || [])
    this.filenameTarget.textContent = files.length
      ? files.map((file) => file.name).join(", ")
      : this.placeholderValue
  }

  dragOver(event) {
    event.preventDefault()
    if (this.hasDraggingClass) this.element.classList.add(...this.draggingClasses)
  }

  dragLeave() {
    if (this.hasDraggingClass) this.element.classList.remove(...this.draggingClasses)
  }

  drop(event) {
    event.preventDefault()
    this.dragLeave()
    if (!event.dataTransfer?.files?.length) return

    this.inputTarget.files = event.dataTransfer.files
    // Como si se hubiera elegido a mano: actualiza el nombre (file-field#changed)
    // y avisa al formulario (autoguardado).
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
